import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ResultComponent from '@Components/Results/result.component';
import Tooltip, { TooltipConstants } from '@Components/Tooltip';
import { InfoTooltipOnClick } from '@Components/InfoTooltip';

function ResultsListComponent({
  size,
  results,
  gridView,
  metadata,
  context,
  updateItemChecked,
  searchType,
  originalSearchType,
  hideCheckbox,
}) {
  if (!results.length) return null;

  const containerProps = {
    className: cn(
      'e2e-results-list',
      'rx-list',
      `rx-list--${context}`,
      `${metadata.heatmapMode ? 'rx-list-heatmap' : 'rx-left-gutter rx-right-gutter'}`,
      'rx-list-react'
    ),
    'aria-label': 'Results List',
    role: 'search',
  };

  const tooltipId = Tooltip.TooltipConstants.ids.ResultsListComponent;

  const resultProps = {
    metadata,
    context,
    updateItemChecked,
    searchType,
    originalSearchType,
    gridView,
    hideCheckbox,
    size,
  };

  return (
    <>
      <ul {...containerProps}>
        {results.map((result) => (
          <li className="e2e-results-list-item rx-list-item" key={result.index}>
            <ResultComponent result={result} {...resultProps} />
          </li>
        ))}
      </ul>
      <Tooltip id={TooltipConstants.ids.ResultStructureComponent} />
      <Tooltip id={tooltipId} />
      <InfoTooltipOnClick id={TooltipConstants.ids.ResultFilterComponent} place="right" className="centerArrow" />
    </>
  );
}

ResultsListComponent.defaultProps = {
  updateItemChecked: () => {},
};

ResultsListComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  context: PropTypes.string.isRequired,
  updateItemChecked: PropTypes.func,
  results: PropTypes.array.isRequired,
  size: PropTypes.number.isRequired,
  gridView: PropTypes.bool,
  searchType: PropTypes.string,
  originalSearchType: PropTypes.string,
  hideCheckbox: PropTypes.bool,
};

export default ResultsListComponent;
